import Chart from "chart.js";

Chart.defaults.global.defaultFontFamily = "'Raleway', 'Roboto', 'Helvetica', 'Arial'";



// WEBPACK FOOTER //
// ./src/config/chart.js